import { Navigate } from 'react-router-dom';
import { useOrgProfile } from '@/hooks/useOrgProfile';
import type { NavRequires } from '@/config/navConfig';

/**
 * Gate de ruta por perfil de organización (migración 150).
 *
 * HOY solo aplica `profile` / `profileNot` — es la capacidad nueva que habilita
 * el vertical cowork. NO gatea por `can` (permisos): las rutas del panel nunca
 * estuvieron gateadas por permiso a nivel router (cada página se auto-protege),
 * y este refactor mueve el menú, no cambia esa política. Para gatear también por
 * permiso más adelante, añadir el check de `requires.can` acá.
 */
export default function GuardedRoute({
  requires,
  children,
}: {
  requires?: NavRequires;
  children: React.ReactNode;
}) {
  const { profile } = useOrgProfile();

  if (requires?.profile && !requires.profile.includes(profile)) {
    return <Navigate to="/" replace />;
  }
  if (requires?.profileNot && requires.profileNot.includes(profile)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
